import { reactive } from 'vue';
import { formatPoints, getUserPoints } from '@/api/sales/points';
import { isScoringMatrixAvailable } from '@/services/pointsMatrixService';
import { isSyncCompleted } from '@/sync/dataSync';
import { eventBus } from '@/utils/core/eventBus';

// The user's points total for the chrome's user menu (#22908), formerly a badge WidgetLayout injected into the
// legacy nav: shown when the customer has a scoring matrix and a scoring period is running. Read after the main
// synchronization (the points dialog zone is mounted then), and again whenever a claim changes the points.
const summary = reactive({ available: false, total: '' });
let listening = false;
let requestToken = 0;

export async function refreshPointsSummary() {
	const token = ++requestToken;
	const points = isScoringMatrixAvailable() ? await getUserPoints().catch(() => null) : null;
	if (token !== requestToken) return;
	summary.available = Boolean(points?.season);
	summary.total = formatPoints(points?.total ?? 0);
}

export function usePointsSummary() {
	if (!listening) {
		listening = true;
		window.addEventListener('points-updated', refreshPointsSummary);
		eventBus.on('main-sync-completed', refreshPointsSummary);
		if (isSyncCompleted()) refreshPointsSummary();
	}
	return summary;
}
